import { render, staticRenderFns } from "./tag-ai-form.vue?vue&type=template&id=0bae7d64&scoped=true"
import script from "./tag-ai-form.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-ai-form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae7d64",
  null
  
)

export default component.exports